<div 
  class="flex justify-center items-center min-w-[90] h-[72px] bg-white rounded-xl shadow-md overflow-hidden cursor-pointer transition-all duration-300 hover:-translate-y-1 hover:shadow-lg"
  [class.bg-blue-100]="isClicked"
  [class.scale-102]="isClicked"
  (click)="onClick(data?.value ?? '')"
>
  <!-- img content (40% of width) -->
  <div class="flex justify-center items-center w-[40%] h-full overflow-hidden">
    <img 
      [src]="imageUrl" 
      [alt]="data?.label" 
      [class]="data?.img == 'img/tickets.png'|| data?.img == 'img/hands.png' ? 'p-1' : 'p-0'"
      class="w-auto h-10 object-cover object-center transition-transform duration-300"
      [class.brightness-90]="isClicked"
    >
  </div>
  
  <!-- text content (60% of width) -->
  <div class="flex-1 flex items-center justify-start p-5">
    <p class="text-gray-800 text-lg text-center m-0 text-secundary"
       [class.font-medium]="isClicked">
      {{ data?.label | titlecase }}
    </p>
  </div>
</div>